import React, { useState, createContext, useContext } from 'react';

// 1. Create a Context
const GenAIContext = createContext();

// 2. Create the Wrapper Component (Provider)
export const GenAIWrapper = ({ children, apiKey }) => {
    return (
        <GenAIContext.Provider>
            {children}
        </GenAIContext.Provider>
    );
};
